import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import * as Rule from "../state/Rule";
import { iReference } from "../state/Reference";
import { Result, isResolved } from "../Status";
import { scalarValue } from "../../../../../stream";

export function getReferencedNode(resolved_reference: api_cs.Cresolved__status): api_cs.Cnode {
	const resolvable = resolved_reference.parent.input.resolvable();
	let node: Result<api_cs.Cnode>;
	switch (resolvable.variant.name) {
		case "reference":
			node = iReference(resolvable.variant.definition).referencedNode.value;
			break;
		case "rule":
			node = scalarValue(Rule.node(resolvable.variant.definition));
			break;
	}
	if (!isResolved(node)) {
		throw new Error("Expected value to be a node of a resolved object.");
	}
	return node;
}

export function isBusyResolving(resolve_status: api_cs.Cresolve_status): boolean {
	switch (resolve_status.properties.status.state.name) {
		case "failed to resolve":
			return false;
		case "is busy resolving":
			return true;
		case "resolved":
			return false;
		case "unresolved":
			return false;
	}
}

export async function isResolvedPromise(resolve_status: api_cs.Cresolve_status): Promise<void> {
	if (isBusyResolving(resolve_status) === false) return Promise.resolve();
	return new Promise((resolve) => {
		resolve_status.properties.status.subscribe({
			on_update: (_, subscription) => {
				if (isResolved(resolve_status)) {
					subscription.unsubscribe();
					resolve();
				}
			},
		});
		resolve_status.onDestroy(() => resolve());
	});
}
